import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbIterable } from "abweb/collection/AbIterable";
import { ApplicationNotification } from "abweb/service/notification/ApplicationNotification";
import { ApplicationNotificationSeverity } from "abweb/service/notification/ApplicationNotificationSeverity";
import { action, observable, makeObservable, runInAction } from "mobx";
export let NotificationService = (_dec = observable.shallow, _class = class NotificationService {
  constructor() {
    _initializerDefineProperty(this, "_notifications", _descriptor, this);
    _initializerDefineProperty(this, "_maxSeverity", _descriptor2, this);
    _initializerDefineProperty(this, "_fetchNotifications", _descriptor3, this);
    _defineProperty(this, "activeNotificationSeenListeners", new Set());
    makeObservable(this);
    this._notifications = [];
    this._maxSeverity = null;
    this._fetchNotifications = undefined;
  }

  /**
   * Gets a sorted copy of the Application Notifications array, with the most important first
   */
  get notifications() {
    return this._notifications.slice().sort(ApplicationNotification.compare).reverse();
  }

  /**
   * Gets the number of notifications
   */
  get totalNotificationCount() {
    return this._notifications.length;
  }
  get notificationsRequiringAttentionCount() {
    return AbIterable.from(this._notifications).filter(n => n.requiresAttention).count();
  }
  get unseenNotificationCount() {
    return AbIterable.from(this._notifications).filter(n => !n.seen).count();
  }

  /**
   * Gets the highest notification severity in use
   */
  get maxSeverity() {
    return this._maxSeverity;
  }

  /**
   */
  get fetchNotifications() {
    return this._fetchNotifications;
  }
  set fetchNotifications(value) {
    runInAction(() => this._fetchNotifications = value);
  }

  /**
   * Add an ApplicationNotification to the list. A given message can only be added
   * once, so if the notification is already in the list, it will not be re-added.
   *
   * @param msg   the ApplicationNotification
   * @return      Flag indicating whether the message was added.
   *
   */
  addNotification(notification) {
    if (this._notifications.indexOf(notification) !== -1) {
      return false;
    }
    this._notifications.push(notification);
    if (this._maxSeverity === null || ApplicationNotificationSeverity.compare(notification.severity, this._maxSeverity) > 0) {
      this._maxSeverity = notification.severity;
    }
    return true;
  }

  /**
   * Removes a notification from the list
   *
   * @param msg   the ApplicationNotification to remove
   * @return      Flag indicating the notification has been removed
   *
   */
  removeNotification(notification) {
    const index = this._notifications.indexOf(notification);
    if (index === -1) {
      return false;
    }
    this._notifications.splice(index, 1);
    if (this._notifications.length === 0) {
      this._maxSeverity = null;
    } else {
      // Note that this uses the notifications property (which is sorted), not the _notifications field, which is not
      this._maxSeverity = this.notifications[0].severity;
    }
    return true;
  }
  async onNotificationSeen(notifications) {
    const promises = [];
    for (const listener of this.activeNotificationSeenListeners) {
      promises.push(listener(notifications));
    }
    await Promise.all(promises);
  }
  listenForNotificationsSeen(onNotificationSeen) {
    this.activeNotificationSeenListeners.add(onNotificationSeen);
    return () => this.activeNotificationSeenListeners.delete(onNotificationSeen);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_notifications", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_maxSeverity", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_fetchNotifications", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addNotification", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addNotification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeNotification", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeNotification"), _class.prototype), _class);
//# sourceMappingURL=NotificationService.js.map
